import { useFormik } from "formik";
import React, { Fragment, useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import slider1 from "../../assets/images/slider1.svg";
import slider2 from "../../assets/images/slider2.svg";
import slider3 from "../../assets/images/slider3.svg";
import AlertContext from "../../context/Alert/AlertContext";
import AuthContext from "../../context/Auth/AuthContext";
import axiosPrivate from "../../hooks//axiosPrivate";
import classes from "./SignUp.module.css";
import logo from "./../../../src/assets/img/logo.png";
import LoaderContext from "../../context/loader/LoaderContext";
import { showErrorToast, showSuccessToast } from "../../Toster";

const passwordInitalValues = {
  password: "",
  confirmPassword: "",
};

const ForgatPassword = () => {
  const { user, setUser, userDetails, setUserDetails } =
    useContext(AuthContext);

  const { setIsLoading } = useContext(LoaderContext);
  const { setAlertMessage } = useContext(AlertContext);
  const [loginScreen, setLoginScreen] = useState(true);
  const [loginMobileNumber, setLoginMobileNumber] = useState("");
  const [otpNumber, setOtpNumber] = useState("");
  const [otpErrorNumber, setOtpErrorNumber] = useState("");
  const navigate = useNavigate();
  const [timer, setTimer] = useState(59); // Timer for OTP countdown
  const [showResendOtp, setShowResendOtp] = useState(false); // To show/hide resend OTP button
  const [startTimer, setStartTimer] = useState(true);
  const [otpSend, setOtpsend] = useState(false);
  const [verifyOtp, setVerifyOtp] = useState(false);
  const [passwordValues, setPasswordValues] = useState(passwordInitalValues);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const validationRules = {
    mobile: Yup.string()
      .required("Mobile number is required")
      .matches(/^[6-9]\d{9}$/, {
        message: "Please enter valid number.",
        excludeEmptyString: false,
      })
      .min("10", "Mobile number must be of 10 digits")
      .max("10", "Mobile number must be of 10 digits"),
  };

  const getUserDetails = (id) => {
    axiosPrivate
      .get(`users/get/${id}`)
      .then((response) => {
        if (response.data.code == 200) {
          localStorage.setItem(
            "userDetails",
            JSON.stringify(response.data.data)
          );
          setUserDetails(response.data.data);
          if (response.data.data.role == 8) {
            navigate("/user/dashboard");
          } else {
            navigate("/admin/dashboard");
          }
        }
      })
      .catch((error) => {});
  };

  const setLoginCredentials = (mobile) => {
    setLoginMobileNumber(mobile);
    return true;
  };

  const formik = useFormik({
    initialValues: {
      mobile: "",
      otp: "",
    },
    validationSchema: Yup.object(validationRules),
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      if (!otpSend) {
        axiosPrivate
          .post("/login-otp", values)
          .then((response) => {
            if (response.data.code == 200) {
              setLoginCredentials(values.mobile);
              showSuccessToast("OTP send successfully.");
              setLoginMobileNumber(values.mobile);
              setOtpsend(true);
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 401) {
                showErrorToast(error.response.data.message);
              } else if (error.response.status === 422) {
                showErrorToast(
                  error?.response?.data?.errors[0]?.msg || "User Not found"
                );
              } else {
                showErrorToast("Invalid mobile number");
              }
            } else {
              showErrorToast("Error occurred");
            }
          });
      }

      if (otpSend && !verifyOtp) {
        handleOtpFormSubmit();
      }

      if (otpSend && verifyOtp) {
        if (passwordValues.password !== passwordValues.confirmPassword) {
          showErrorToast("Password and Confirm Password do not match");
          return;
        }
        let newValuesForLogin = {
          mobile: loginMobileNumber,
          password: passwordValues.password,
        };
        if (otpNumber) {
          setOtpErrorNumber("");

          await axiosPrivate
            .post("/save-password", newValuesForLogin)
            .then((response) => {
              showSuccessToast("Password Change");
              navigate("/user-panel/signin");
            })
            .catch((error) => {
              showErrorToast(error?.response?.data?.message);
            });
        } else {
          setOtpErrorNumber("OTP is Required");
        }
      }
      // if(values?.mobile) {
      // }
    },
  });

  const resendOtpHandler = async () => {
    await axiosPrivate
      .post("/login-otp", { mobile: loginMobileNumber })
      .then(() => {
        showSuccessToast("OTP resend successfully.");

        setTimer(59); // Reset the timer
        setShowResendOtp(false); // Hide the "Resend OTP" button
        setStartTimer(!startTimer);
      })
      .catch((error) => {
        showErrorToast("Failed to resend OTP. Please try again.");
      });
  };

  const handleOtpFormSubmit = async () => {
    let newValuesForLogin = {
      mobile: loginMobileNumber,
      otp: otpNumber,
    };
    if (otpNumber) {
      setOtpErrorNumber("");

      await axiosPrivate
        .post("/login", newValuesForLogin)
        .then((response) => {
          setVerifyOtp(true);
          showSuccessToast("OTP verified successfully.");
        })
        .catch((error) => {
          showErrorToast(error?.response?.data?.message);
        });
    } else {
      setOtpErrorNumber("OTP is Required");
    }
  };

  // Start the timer when the OTP screen is displayed
  useEffect(() => {
    let interval;
    if (!loginScreen) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 0) {
            clearInterval(interval); // Clear the interval when the timer reaches 0
            setShowResendOtp(true); // Show the "Resend OTP" button
            return prev;
          }
          return prev - 1;
        });
      }, 1000); // Decrement every second
    }

    // Cleanup interval on component unmount or when switching screens
    return () => clearInterval(interval);
  }, [loginScreen, startTimer]);

  return (
    <Fragment>
      <div className="auth_left">
        <div className="card">
          <div className="text-center mb-2">
            <Link className="header-brand" to="/">
              <img src={logo} />
            </Link>
          </div>
          <div className="card-body">
            {loginScreen ? (
              // Login screen start
              <form key={1} onSubmit={formik.handleSubmit}>
                <div className="card-title">
                  <label className="form-label">Forgat your Password </label>
                </div>

                {!otpSend && !verifyOtp && (
                  <div className="form-group">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      name="mobile"
                      className="form-control"
                      onChange={(event) => {
                        formik.handleChange(event);
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.mobile}
                      placeholder="Mobile number"
                    />

                    {formik.touched.mobile && formik.errors.mobile ? (
                      <div className={classes.invalidDataError}>
                        {formik.errors.mobile}
                      </div>
                    ) : null}
                  </div>
                )}

                {otpSend && !verifyOtp && (
                  <div className="form-group">
                    <label className="form-label">Otp</label>
                    <input
                      type="number"
                      name="otp"
                      className="form-control"
                      onChange={(event) => {
                        setOtpNumber(event.target.value);
                      }}
                      onBlur={formik.handleBlur}
                      value={otpNumber}
                      placeholder="Enter otp"
                    />

                    {otpErrorNumber && (
                      <div className={classes.invalidDataError}>
                        {otpErrorNumber}
                      </div>
                    )}
                  </div>
                )}

                {verifyOtp && (
                  <>
                    <div className="form-group">
                      <label className="form-label">New Password</label>
                      <input
                        type="password"
                        name="password"
                        className="form-control"
                        onChange={(event) => {
                          setPasswordValues((prev) => ({
                            ...prev,
                            [event.target.name]: event.target.value,
                          }));
                        }}
                        onBlur={formik.handleBlur}
                        value={passwordValues.password}
                        placeholder="password"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Confirm New Password</label>
                      <input
                        type="text"
                        name="confirmPassword"
                        className="form-control"
                        onChange={(event) => {
                          setPasswordValues((prev) => ({
                            ...prev,
                            [event.target.name]: event.target.value,
                          }));
                        }}
                        onBlur={formik.handleBlur}
                        value={passwordValues.confirmPassword}
                        placeholder="password"
                      />

                      {true && (
                        <div className={classes.invalidDataError}>
                          {formik.errors.otp}
                        </div>
                      )}
                    </div>
                  </>
                )}
                {/* 
                <div className='form-footer'>
                  {showResendOtp && (
                    <input
                      type='button'
                      onClick={resendOtpHandler}
                      className='btn btn-primary btn-block'
                      id='login-verify'
                      value='Resend OTP'
                    />
                  )}
                </div>

                {otpSend && (
                  <div className='mt-2 d-flex justify-content-end'>
                    {!showResendOtp && <span>Resend OTP in {timer}s</span>}
                  </div>
                )} */}

                {/* Resend OTP Section */}

                <div className="form-footer">
                  <input
                    type="submit"
                    id="login-submit"
                    className="btn btn-primary btn-block"
                    value="Submit"
                  />
                </div>
                <div className="text-center mt-4">
                  <Link to="/user-panel/signin" className="btn btn-link">
                    Login
                  </Link>
                </div>
              </form>
            ) : (
              // Login screen end
              // Otp screen start
              ""
              // Otp screen end
            )}
          </div>
        </div>
      </div>
      <div className="auth_right">
        <div
          className="carousel slide"
          data-ride="carousel"
          data-interval={3000}
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={slider1} className="img-fluid" alt="login page" />
              <div className="px-4 mt-4">
                <h4>Fully Responsive</h4>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
              </div>
            </div>
            <div className="carousel-item">
              <img src={slider2} className="img-fluid" alt="login page" />
              <div className="px-4 mt-4">
                <h4>Quality Code and Easy Customizability</h4>
                <p>
                  There are many variations of passages of Lorem Ipsum
                  available.
                </p>
              </div>
            </div>
            <div className="carousel-item">
              <img src={slider3} className="img-fluid" alt="login page" />
              <div className="px-4 mt-4">
                <h4>Cross Browser Compatibility</h4>
                <p>
                  Overview We're a group of women who want to learn JavaScript.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgatPassword;
